import { render, staticRenderFns } from "./altaEstadoPromocion.vue?vue&type=template&id=680800fa&scoped=true"
import script from "./altaEstadoPromocion.vue?vue&type=script&lang=js"
export * from "./altaEstadoPromocion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680800fa",
  null
  
)

export default component.exports